import { XCircle } from "lucide-react";

export default function PayCancel() {
  return (
    <div className="min-h-screen brand-glow flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <XCircle className="mx-auto h-14 w-14 text-muted-foreground mb-4" />
        <h1 className="text-2xl font-bold">Payment canceled</h1>
        <p className="mt-3 text-muted-foreground">
          No charge was made. You can reopen your payment link any time to complete it.
        </p>
        <p className="mt-8 text-sm text-muted-foreground">
          Questions? Email <a className="text-primary" href="mailto:info@averoan.com">info@averoan.com</a>
        </p>
      </div>
    </div>
  );
}
